import { createSelector } from '@reduxjs/toolkit';
export const userReducerSelector = (state) => state.user;
export const userProjectsSelector = createSelector(userReducerSelector, (user) => user.projects);
export const activeUserSelector = createSelector(userReducerSelector, (reducer) => reducer.asset);
